// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zjuj","textarea":"styles_textarea__3-HoA"};